import { render } from "./report-box.vue?vue&type=template&id=305dc4fe&scoped=true"
import script from "./report-box.vue?vue&type=script&lang=js"
export * from "./report-box.vue?vue&type=script&lang=js"

import "./report-box.vue?vue&type=style&index=0&id=305dc4fe&scoped=true&lang=css"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-305dc4fe"]])

export default __exports__